import { render, staticRenderFns } from "./AppInfoModal.vue?vue&type=template&id=82c6999a&scoped=true"
import script from "./AppInfoModal.vue?vue&type=script&lang=js"
export * from "./AppInfoModal.vue?vue&type=script&lang=js"
import style0 from "./AppInfoModal.vue?vue&type=style&index=0&id=82c6999a&prod&scoped=true&lang=scss"
import style1 from "./AppInfoModal.vue?vue&type=style&index=1&id=82c6999a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c6999a",
  null
  
)

export default component.exports